import React, { Component } from "react";
import "../assets/css/footer.css";
import appleLogo from "../assets/images/apple-logo.png";
import playStore from "../assets/images/playstore.png";

class Footer extends Component {
  render() {
    return (
      <footer
        style={{
          backgroundColor: "#094EA2",
          color: "#fff",
          padding: "20px 0",
          marginTop: "auto",
        }}
      >
        <div className="container">
          <div className="row align-items-center">

            {/* Copyright */}
            <div className="col-lg-4 col-md-12 text-center text-lg-start mb-3 mb-lg-0">
              <small>
                © {new Date().getFullYear()}{" "}
                <strong>
                  <a
                    href="https://chssoftwares.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#fff",
                      textDecoration: "none",
                    }}
                  >
                    CHS Software Solutions
                  </a>
                </strong>
                . All Rights Reserved.
              </small>
            </div>

            {/* Footer Links */}
            <div className="col-lg-4 col-md-12 text-center mb-3 mb-lg-0">
              <a
                href="/privacy-policy.html"
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  margin: "0 12px",
                }}
              >
                Privacy Policy
              </a>

              {/* <a
                href="/terms-and-conditions"
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  margin: "0 12px",
                }}
              >
                Terms & Conditions
              </a> */}

              {/* <a
                href="/contact-us"
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  margin: "0 12px",
                }}
              >
                Contact Us
              </a> */}
            </div>

            {/* App Download */}
            <div className="col-lg-4 col-md-12 text-center text-lg-end">
              <span
                style={{
                  fontSize: "13px",
                  marginRight: 10,
                }}
              >
                Download Our App
              </span>

              <a href="#" style={{ marginRight: 8 }}>
                <img
                  src={appleLogo}
                  alt="App Store"
                  style={{
                    height: 34,
                    verticalAlign: "middle",
                  }}
                />
              </a>

              <a href="#">
                <img
                  src={playStore}
                  alt="Google Play"
                  style={{
                    height: 34,
                    verticalAlign: "middle",
                  }}
                />
              </a>
            </div>

          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;